<template>
  <div>
    <!-- Button trigger modal -->
    <button type="button" class="btn btn-primary" data-toggle="modal" :data-target="`#modal-assignments-${project.id}`">
      Revisar asignaciones
    </button>

    <!-- Modal -->
    <div class="modal fade" :id="`modal-assignments-${project.id}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document" id="assignments-quality">
        <div class="modal-content">
          <div class="modal-header">
            <template v-if="assignment != null">
              <h5 class="modal-title" id="exampleModalLabel">
                Asignación
              </h5>
            </template>            
            <template v-else>
              <h5 class="modal-title" id="exampleModalLabel">
                Asignaciones
              </h5>
            </template>                        
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="button-massive">
            <button class="btn btn-success" @click.prevent="approveRefuseAssignments(1)">Aprobar todas las asignaciones</button>
            <button class="btn btn-danger" @click.prevent="approveRefuseAssignments(0)">Rechazar todas las asignaciones</button>          
          </div>
          <div class="modal-body">
            <div :class="typeMessage" role="alert" v-if="message != ''">
              {{message}}
            </div>
            <table class="table" id="projects">
              <thead>
                <tr>
                  <th>Proceso</th>
                  <th>Asignación</th>
                  <th>Fecha</th>
                  <th>Aspirante</th>
                  <th>Estado</th>
                  <th>Proceso</th>
                  <th>Ciudad</th>
                  <th>tipo</th>
                  <th>Calidad</th>
                  <th>Revisar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="assignment != null">
                  <td>{{project.id}}</td>
                  <td>{{assignment.id}}</td>
                  <td>{{project.created_at | parseDate }}</td>                  
                  <td>{{person_full_name}}</td>           
                  <td>{{status_name}}</td>                         
                  <td>{{project_type_name}}</td>                  
                  <td>{{city_name}}</td>                                    
                  <td>{{getAssignmentTypeName(assignment.assignment_type_id)}}</td>
                  <td v-if="assignment != null">
                    <template v-if="assignment.quality"><b> Aprobado </b></template>
                    <template v-else><b> Rechazados </b></template>
                  </td>
                  <td v-else>No revisado</td>           
                  <td>
                    <a type="button" class="btn btn-primary" :href="`/clients/${project.client_id}/project?project_id=${project.id}`" target="_blank" v-if="assignment.assignment_type_id == 4">Ver</a>
                    <a type="button" class="btn btn-primary" :href="`/workers/work/${assignment.id}`" target="_blank" v-else>Ver</a>
                  </td>
                  <td v-if="assignment.quality != null">                    
                    <a type="button" class="btn btn-primary" @click.prevent="approveAssignment(false)" v-if="assignment.quality">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                      </svg>
                    </a>                                        
                    <button type="button" class="btn btn-primary" @click.prevent="approveAssignment(true)" v-else>
                      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"></path>
                      </svg>
                    </button>                    
                  </td>                                    
                  <template v-else>                    
                    <td>
                      <button type="button" class="btn btn-primary" @click.prevent="approveAssignment(false)">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                      </button>                                                            
                    </td>
                    <td>
                      <button type="button" class="btn btn-primary" @click.prevent="approveAssignment(true)">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"></path>
                        </svg>
                      </button>                                        
                    </td>
                  </template>                                               
                  <td>
                    <a class="btn btn-primary" @click.prevent="closeAssignment" target="_blank">Cerrar</a>
                  </td>                                    
                </tr>                              
                <tr v-for="assignment_iterado in assignmentsLocal" :key="assignment_iterado.id" v-else>
                  <td>{{project.id}}</td>
                  <td>{{assignment_iterado.id}}</td>
                  <td>{{project.created_at | parseDate }}</td>                  
                  <td>{{person_full_name}}</td>           
                  <td>{{status_name}}</td>                         
                  <td>{{project_type_name}}</td>                  
                  <td>{{city_name}}</td>                                    
                  <td>{{getAssignmentTypeName(assignment_iterado.assignment_type_id)}}</td>
                  <td v-if="assignment_iterado != null">
                    <template v-if="assignment_iterado.quality"><b> Aprobado </b></template>
                    <template v-else><b> Rechazados </b></template>
                  </td>
                  <td v-else>No revisado</td>                  

                  <td>
                    <a class="btn btn-primary" @click.prevent="viewAssignment(assignment_iterado)" target="_blank">Ver</a>
                  </td>                  
                </tr>
              </tbody>
            </table>
            <div class="form-group" v-if="requestObservationTouser">
              <label for="observation">Observación</label>
              <select class="form-control" v-model="observation">
                <option disabled value="">Textos predefinidos para las observaciones</option>
                <option v-for="observation in observations" :key="observation" v-bind:value="observation">{{observation}}</option>
              </select>                                
              <textarea v-model="observation" class="form-control" id="observation" rows="5"></textarea>
              <button @click.prevent="sendApproveAssignment" type="button" class="btn btn-primary">Guardar</button>
            </div>                                    
            <div class="" v-if="assignment != null">
              <h5 class="modal-title" id="exampleModalLabel">
                Historial de revisiones
              </h5>            
              <table class="table" id="projects">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Resultado</th>
                    <th>Usuario</th>
                    <th>email</th>
                    <th>Observación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="quality_history in quality_histories" :key="quality_history.id">
                    <td>{{quality_history.id}}</td>
                    <td>{{quality_history.created_at | parseDate }}</td>
                    <td>{{quality_history.quality | parseQuality }}</td>                  
                    <td>{{quality_history.full_name}}</td>                  
                    <td>{{quality_history.email}}</td>                  
                    <td>{{quality_history.observation}}</td>
                  </tr>
                </tbody>
              </table>            
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Assignments",
  props: ['project', 'assignments', 'assignment_types', 'person_full_name', 'project_type_name', 'city_name', 'status_name', 'user'],
  data() {
    return {
      assignment: null,
      typeMessage: '',
      message: '',
      observation: 'Por favor ingrese la observación',
      observations: [
        'Se revisa informe entregado por la psicóloga encargada del proceso, se realizan algunas correcciones de ortografía y redacción permitiendo así un mejor entendimiento del mensaje transmitido por la profesional.',
        'Se confirma que la información descargada corresponde al número de documento del candidato, no se encuentra información adversa .',
        'Se revisa informe entregado por la profesional de visitas domiciliarias, no se encuentran errores ortográficos ni de redacción; se aprueba.',
        'El proceso realizado para la verificación académica estuvo acorde a las necesidades del mismo; se confirma que los correos y las llamadas fueron realizadas de manera pertinente; se aprueba por calidad.',
        'Se confirma que la calificación brindada por el analista coincide con el concepto entregado por las referencias; no se encuentran errores de ortografía o redacción, el comentario es claro y conciso.',
        'Se revisa redacción y ortografía plasmada en los comentarios, dejando claridad que ambas referencias fueron contestadas textualmente por el contacto brindado por el candidato.',
        'Se confirma que la información pertenece al número de documento del candidato, de encontrarse novedades serán siempre reportadas directamente al cliente. ',
      ],
      requestObservationTouser: false,
      quality: null,
      quality_histories: [],
      assignmentsLocal: this.assignments
    }
  },
  methods: {
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    async viewAssignment (assignment) {
      this.assignment = assignment
      let request = await axios.get(`/get_quality_histories?assignment_id=${this.assignment.id}`, {}, {})
      if (request.status == 200) {
        this.quality_histories = request.data.quality_histories
      }      
    },
    closeAssignment(){
      this.assignment = null
      this.requestObservationTouser = false
    },
    getAssignmentTypeName (value) {
      return this.assignment_types.filter( assignment_type => assignment_type.id == value )[0].name
    },
    approveAssignment(quality) {
      this.showMessage('Por favor ingrese la observacion', 'alert-success', 30000)
      this.requestObservationTouser = true
      this.quality = quality
    },
    async sendApproveAssignment() {
      let request = await axios.get(`/update_quality_assignment?assignment_id=${this.assignment.id}&quality=${this.quality}&user_id=${this.user.id}&observation=${this.observation}`, {}, {})
      if (request.status == 200) {
        this.assignment = request.data.assignment
        this.assignmentsLocal = request.data.assignments
        this.showMessage(request.data.message, 'alert-success', 3000)
        this.viewAssignment(this.assignment)
        this.requestObservationTouser = false
      } else {
        this.showMessage('Error', 'alert-danger', 3000)
      }
    },
    async approveRefuseAssignments(value) {
      let request = await axios.get(`/approve_refuse_assignments?project_id=${this.project.id}&quality=${value}`, {}, {})
      if (request.status == 200) {
        this.assignmentsLocal = request.data.assignments
        this.showMessage(`${request.data.message}. Asignaciones actualizadas ${request.data.count_assignments_update}`, 'alert-success', 10000)
        this.requestObservationTouser = false
      } else {
        this.showMessage('Error', 'alert-danger', 10000)
      }
    },
    showMessage(message, typeMessage, time){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', time)
    },        
  },
  filters: {
    parseDate: function(value) {
      let date = new Date(value)
      let datestring = date.getDate()  + "-" + (date.getMonth()+1) + "-" + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      return datestring;
    },
    parseQuality: function(quality) {
      if (quality != null) {
        return quality ? 'Aprobado' : 'Rechazados'
      } else {
        return 'Sin revisión'
      }      
    }    
  }
}
</script>

<style scoped>

</style>

